import React from "react";
import { useNavigate } from "react-router-dom";

import { FaArrowCircleLeft } from "react-icons/fa";

import "./GoBackLink.css";

function GoBackLink({ link }) {
  const navigate = useNavigate();
  return (
    <div className="go-back-link" onClick={() => navigate(link)}>
      <FaArrowCircleLeft size={18} />
      <p>Go Back</p>
    </div>
  );
}

export default GoBackLink;
